module.exports = __webpack_public_path__ + "img/22.9f6eb24e.jpg";